























































import { MediaSource } from '@/services/Media';

import ImportIMDbMoviesModal from '@/components/modals/ImportIMDbMoviesModal.vue';
import Modal from '@/components/mixins/Modal';

import CSV from '@/utils/CSV';
import Files, { MediaType } from '@/utils/Files';
import Time from '@/utils/Time';

export default Modal.extend({
    data: () => ({
        sources: Object.values(MediaSource),
    }),
    computed: {
        mediaSourceNames: () => ({
            [MediaSource.IMDb]: 'IMDb',
            [MediaSource.Netflix]: 'Netflix',
            [MediaSource.JSONLD]: 'JSON-LD',
            [MediaSource.TViso]: 'TViso',
            [MediaSource.GoodFilms]: 'Good Fil.ms',
        }),
        helpReplacements(): any {
            const filePath = 'docs#data-schema';
            const tag = this.$app.isDevelopment ? 'main' : this.$app.versionName;

            return {
                jsonld: {
                    url: `${this.$app.sourceUrl}/blob/${tag}/${filePath}`,
                },
            };
        },
        requestSourceUrl(): string {
            return `${this.$app.sourceUrl}/issues/new?title=Support+importing+movies+from+...`;
        },
    },
    methods: {
        async openSearch() {
            this.close();

            // Wait for the modal to be hidden.
            await Time.wait(350);

            this.$search.start();
        },
        async importMedia(source: MediaSource) {
            try {
                const data = await this.getSourceData(source);

                if (data.length === 0) {
                    return;
                }

                await this.$media.importMovies(data, source);

                this.close();
            } catch (error) {
                this.$ui.alert(
                    'Import failed',
                    'There was a problem importing that file, are you sure it\'s in the correct format?',
                );
            }
        },
        async getSourceData(source: MediaSource): Promise<object[]> {
            switch (source) {
                case MediaSource.IMDb:
                    return this.getDataFromModal();
                case MediaSource.GoodFilms:
                case MediaSource.Netflix:
                    return this.getDataFromFile(MediaType.CSV);
                default:
                    return this.getDataFromFile(MediaType.JSON);
            }
        },
        async getDataFromFile(format: MediaType): Promise<object[]> {
            const fileContents = await Files.upload({ accept: format });
            if (fileContents === null)
                return [];

            const data = this.parseData(format, fileContents);
            if (!Array.isArray(data))
                throw new Error('Invalid file format, expecting array');

            return data;
        },
        async getDataFromModal(): Promise<object[]> {
            const modal = this.$ui.openModal<object[]>(ImportIMDbMoviesModal);
            const data = await modal.result;

            return data || [];
        },
        parseData(format: MediaType, fileContents: string): unknown {
            return {
                [MediaType.JSON]: () => JSON.parse(fileContents),
                [MediaType.CSV]: () => CSV.parse(fileContents),
            }[format]();
        },
    },
});
